import { Grid, FormControl, InputLabel, Select, MenuItem, Tooltip, Icon } from "@mui/material";
import { useEffect, useState } from "react";
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

export default function FormulaFieldComponent({
  fieldMeta,
  setFieldMeta,
  formulaParams,
  setFormulaParams,
  addParam,
  dataFormFields,
  initialMeta,
}) {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    if (initialMeta && !hydrated) {
      setFieldMeta({
        formula: initialMeta.formula || "",
      });

      if (initialMeta.parameters) {
        setFormulaParams(initialMeta.parameters);
      }

      setHydrated(true);
    }
  }, [initialMeta, hydrated]);
  return (
    <MDBox mt={3}>
      <MDBox mt={2}>
        <MDInput
          name="formular"
          margin="dense"
          label="Mathematical Formula"
          placeholder="Write your formula. Ex: (P1 + P2) - P3 / P4 * 100"
          type="text"
          multiline
          minRows={1}
          fullWidth
          variant="outlined"
          value={fieldMeta?.formula || ""}
          onChange={(e) =>
            setFieldMeta({
              ...fieldMeta,
              formula: e.target.value,
            })
          }
          InputLabelProps={{
            shrink: true,
          }}
        />
        <MDTypography ml={0.5} variant="h6" fontWeight="light" fontSize={14}>
          Supported Operators:&nbsp;<b>+ - / * ( )</b>
        </MDTypography>
      </MDBox>

      <MDBox mt={3}>
        <MDBox p={1} display="flex" justifyContent="space-between">
          <MDBox>
            <MDTypography variant="h6" fontWeight="regular" fontSize={14}>
              Formula Parameters
            </MDTypography>
          </MDBox>
          <MDBox>
            <Tooltip title="Add Parameter">
              <MDButton
                variant="outlined"
                color="dark"
                size="small"
                iconOnly
                onClick={() => {
                  addParam();
                }}
              >
                <Icon>add</Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title="Clear Parameters">
              <MDButton
                variant="outlined"
                color="dark"
                size="small"
                iconOnly
                onClick={() => {
                  setFormulaParams([]);
                }}
              >
                <Icon>clear</Icon>
              </MDButton>
            </Tooltip>
          </MDBox>
        </MDBox>

        <MDBox>
          {formulaParams.map((param, pIdx) => (
            <MDBox mb={1}>
              <Grid container spacing={3}>
                <Grid item xs={3} md={3} lg={3}>
                  <MDInput
                    disabled
                    name="param"
                    margin="dense"
                    label="Parameter"
                    type="text"
                    value={`P${pIdx + 1}`}
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={9} md={9} lg={9}>
                  <MDBox mt={1}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Form Field</InputLabel>
                      <Select
                        label="Form Field"
                        value={formulaParams[pIdx]?.field || ""}
                        onChange={(e) => {
                          const temp = [...formulaParams];

                          temp[pIdx] = {
                            param: `P${pIdx + 1}`,
                            field: e.target.value,
                          };

                          setFormulaParams(temp);
                        }}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                      >
                        {dataFormFields.length > 0 &&
                          dataFormFields.map((record) => (
                            <MenuItem value={`${record.reference}`}>{record.display_name}</MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
          ))}
        </MDBox>
      </MDBox>
    </MDBox>
  );
}
